var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFace = function SvgFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.8,
    d: "M7.7 9.9a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m5.676 1.331a1.1 1.1 0 0 0 .781.319 1.1 1.1 0 0 0 .781-1.881l-.869-.869.869-.869a1.104 1.104 0 1 0-1.562-1.562l-1.65 1.65a1.1 1.1 0 0 0 0 1.562zM11 0a11 11 0 1 0 0 22 11 11 0 0 0 0-22m0 19.8a8.8 8.8 0 1 1 0-17.6 8.8 8.8 0 0 1 0 17.6m2.596-6.347a4.136 4.136 0 0 1-5.192 0 1.101 1.101 0 0 0-1.408 1.694 6.25 6.25 0 0 0 8.008 0 1.101 1.101 0 0 0-1.408-1.694"
  })));
};
export default SvgFace;